import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { formatPrettyDate, fetchEventContentById, beautyTime } from '../utils';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import ReactDOM from 'react-dom/client';
import facebook from '../../../images/fb.png';
import instagram from '../../../images/instagram.png';
import twitter from '../../../images/twitter.png';
import tiktok from '../../../images/tiktok.png';
import iconTalk from '../../../images/map/talk.svg';
import iconExhibit from '../../../images/map/exhibition.svg';
import iconPanel from '../../../images/map/panel.svg';
import iconRetail from '../../../images/map/retail.svg';
import websiteIcon from '../../../images/event-website.png';
import Slider from "react-slick";
var socialIcons = {
  facebook: facebook,
  instagram: instagram,
  tiktok: tiktok,
  twitter: twitter
};
var accessToken = 'pk.eyJ1IjoibnljanciLCJhIjoiY21jMzc3NjV6MDFyeTJrcTU3bWhscDNtYSJ9.-50phwp1452H2lt5AH_8fw';
mapboxgl.accessToken = accessToken;
var EventSlideout = function EventSlideout(props) {
  var _eventContent$dates5, _eventContent$dates6, _eventContent$dates7, _eventContent$event_t, _eventContent$event_t2, _eventContent$event_t3;
  var navigate = useNavigate();
  var params = useParams();
  var curEventType = params.type;
  var currentPath = params.event;
  if (params.supporting) {
    currentPath += "/".concat(params.supporting);
  }
  var mapContainer = useRef(null);
  var map = useRef(null);
  var slideoutRef = useRef(null);
  var slideoutClose = useRef();
  var selectedTestDay = useSelector(function (state) {
    return state.selectedTestDay;
  });
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    today = _useState2[0],
    setToday = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    eventContent = _useState4[0],
    setEventContent = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollPos = _useState6[0],
    setScrollPos = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    closing = _useState10[0],
    setClosing = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showInstructions = _useState12[0],
    setShowInstructions = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    mapMarkers = _useState14[0],
    setMapMarkers = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    locationURL = _useState16[0],
    setLocationURL = _useState16[1];
  var _useState17 = useState(-73.9791500),
    _useState18 = _slicedToArray(_useState17, 2),
    lng = _useState18[0],
    setLng = _useState18[1];
  var _useState19 = useState(40.7590403),
    _useState20 = _slicedToArray(_useState19, 2),
    lat = _useState20[0],
    setLat = _useState20[1];
  var _useState21 = useState(12),
    _useState22 = _slicedToArray(_useState21, 2),
    zoom = _useState22[0],
    setZoom = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    bounds = _useState24[0],
    setBounds = _useState24[1];
  var intro = params.intro ? params.intro : false;
  useEffect(function () {
    if (currentPath !== '') {
      getEventContent(true, intro);
    }
    setToday(selectedTestDay ? new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())) : new Date());
  }, []);

  // Re-fetch event content when route changes to a different event while keeping the same component mounted
  useEffect(function () {
    if (!currentPath) return;
    setLoading(true);
    getEventContent(true, intro);
  }, [currentPath, intro]);
  useEffect(function () {
    if (map.current) {
      populateMarker();
    } else {
      if (!mapContainer.current || !eventContent.location_address) return;
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/nycjw/cmfmzbfmv006l01qk2uka96qy',
        center: [lng, lat],
        zoom: zoom
      });
      map.current.scrollZoom.disable();
      populateMarker();
    }
    var directionsUrl = null;
    if (eventContent && 'location_address' in eventContent && eventContent.location_address !== "") {
      var address = eventContent.location_address.address.replace(/\,/g, '');
      var addressUrl = address.replace(/\ /g, '%20');
      directionsUrl = "https://www.google.com/maps/dir//".concat(addressUrl);
    }
    setLocationURL(directionsUrl);
    window.onpopstate = function (e) {
      closeSlideout(e);
    };
  }, [eventContent]);

  // When event content changes, scroll the slideout container to the top
  useEffect(function () {
    if (!eventContent) return;
    var container = document.getElementById('event-slideout-content-wrapper');
    if (container && typeof container.scrollTo === 'function') {
      container.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else if (container) {
      container.scrollTop = 0;
      container.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [eventContent]);
  var populateMarker = function populateMarker() {
    if (!eventContent || !('location_address' in eventContent) || eventContent.location_address === "") return;
    var ref = /*#__PURE__*/React.createRef();
    // Create a new DOM node and save it to the React ref
    ref.current = document.createElement("div");
    var markerRoot = ReactDOM.createRoot(ref.current);
    var icon = iconPanel;
    if (eventContent.event_types) {
      switch (eventContent.event_types[0].slug) {
        case 'exhibition':
        case 'reception':
        case 'gallery':
          icon = iconExhibit;
          break;
        case 'panel':
        case 'workshop':
          icon = iconPanel;
          break;
        case 'artist-talk':
        case 'talk':
        case 'conversation':
          icon = iconTalk;
          break;
        case 'retail-event':
        case 'shop':
          icon = iconRetail;
          break;
        default:
          icon = iconExhibit;
          break;
      }
    }
    markerRoot.render( /*#__PURE__*/React.createElement("div", {
      className: "map-event-marker"
    }, /*#__PURE__*/React.createElement("img", {
      src: icon
    })));
    // Render a Marker Component on our new DOM node
    var coordinates = new mapboxgl.LngLat(eventContent.location_address.lng, eventContent.location_address.lat);
    // Create a Mapbox Marker at our new DOM node
    new mapboxgl.Marker(ref.current).setLngLat(coordinates).addTo(map.current);
    var bounds = [{
      lat: coordinates.lat - .0008,
      lng: coordinates.lng - .0008
    }, {
      lat: coordinates.lat + .0008,
      lng: coordinates.lng + .0008
    }];
    map.current.fitBounds(bounds, {
      padding: 80
    });
  };
  var toggleShowInstructions = function toggleShowInstructions() {
    setShowInstructions(!showInstructions);
  };
  var getEventContent = function getEventContent(update, intro) {
    setLoading(true);
    setScrollPos(window.scrollY);
    document.body.classList.add('modal-open');
    fetchEventContentById(currentPath).then(function (content) {
      if (content) {
        var timeout = window.screen.width < 768 ? 0 : 250;
        setTimeout(function () {
          setEventContent(content);
          setLoading(false);
        }, timeout);
      } else {
        document.body.classList.remove('modal-open');
        setLoading(false);
        setScrollPos(window.scrollY);
      }
    });
  };
  var closeSlideout = function closeSlideout(event) {
    if (event.type === 'popstate' || slideoutRef && !slideoutRef.current.contains(event.target) || slideoutClose.current.contains(event.target)) {
      event.preventDefault();
      var timeout = window.screen.width < 768 ? 0 : 300;
      document.body.classList.remove('modal-open');
      setClosing(true);
      var closePath = curEventType === 'virtual' ? params.cat === 'instagram' ? "/".concat(curEventType, "/instagram") : "/".concat(curEventType) : "/".concat(curEventType, "/").concat(params.cat);
      setTimeout(function () {
        setClosing(false);
        setEventContent(null);
        navigate('/');
        window.scrollTo(0, scrollPos);
      }, timeout);
    }
    return;
  };
  var borderColor = '#FEF200';
  if (eventContent) {
    if (eventContent.event_themes && eventContent.event_themes.length > 0) {
      borderColor = eventContent.event_themes[0].color ? eventContent.event_themes[0].color : '#FEF200';
    }
  }
  useEffect(function () {
    if (selectedTestDay !== null) {
      setToday(new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())));
    }
  }, [selectedTestDay]);
  var settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  var eventStatus = 'future';
  var rsvpLink = null;
  var rsvpLabel = '';
  if (eventContent) {
    var _eventContent$dates;
    var eventStartDate = new Date(eventContent.event_date + 'T09:00:00');
    var weekStartDate = new Date('2022-11-14T07:00:00');
    var eventEndTime = eventContent.end_time;
    var eventEndDate = new Date(eventContent.event_date + 'T' + eventEndTime);
    rsvpLink = null;
    rsvpLabel = null;
    if (params.type === 'one-time') {
      eventStartDate = eventContent.event_date && eventContent.event_date !== '' ? eventContent.event_date : eventContent.start_date ? eventContent.start_date : eventContent.dates[0].event_date;
      var eventStartTime = eventContent.start_time ? _typeof(eventContent.start_time) === 'object' ? eventContent.start_time.reduce(function (acc, loc) {
        return acc.split(':')[0] < loc.split(':')[0] ? acc : loc;
      }) : eventContent.start_time ? eventContent.start_time : '06:00:00' : '06:00:00';
      // if ( typeof eventContent.start_time === 'object' ) {
      //   eventStartTime = 
      // }
      eventStartDate = new Date(eventStartDate + 'T' + eventStartTime);
      if (today >= eventStartDate) {
        rsvpLabel = eventContent.link ? eventContent.link.title === '' ? 'View Now' : eventContent.link.title : null;
        rsvpLink = eventContent.link ? eventContent.link.url : null;
      } else {
        rsvpLink = eventContent.rsvp ? eventContent.rsvp : null;
        if (_typeof(rsvpLink) === 'object') {
          rsvpLink = rsvpLink.url;
        }
        rsvpLabel = eventContent.rsvp && eventContent.rsvp.title ? eventContent.rsvp.title : 'RSVP';
      }
    }
    if (eventContent.start_date) {
      var _eventStartTime = eventContent.start_time ? eventContent.start_time : '06:00:00';
      eventStartDate = new Date(eventContent.start_date + 'T' + _eventStartTime);
      var _eventEndTime = eventContent.end_time ? eventContent.end_time : '11:59:00';
      eventEndDate = eventContent.end_date ? new Date(eventContent.end_date + 'T' + _eventEndTime) : new Date(eventContent.start_date + 'T' + _eventEndTime);
    }
    if (eventContent.dates && eventContent !== null && eventContent !== void 0 && (_eventContent$dates = eventContent.dates) !== null && _eventContent$dates !== void 0 && _eventContent$dates.length) {
      var _eventContent$dates2, _eventContent$dates3, _eventContent$dates4;
      var _eventStartTime2 = eventContent.dates[0].start_time ? eventContent.dates[0].start_time : '06:00:00';
      eventStartDate = new Date(eventContent.dates[0].event_date + 'T' + _eventStartTime2);
      var _eventEndTime2 = eventContent.dates[(eventContent === null || eventContent === void 0 || (_eventContent$dates2 = eventContent.dates) === null || _eventContent$dates2 === void 0 ? void 0 : _eventContent$dates2.length) - 1].end_time ? eventContent.dates[(eventContent === null || eventContent === void 0 || (_eventContent$dates3 = eventContent.dates) === null || _eventContent$dates3 === void 0 ? void 0 : _eventContent$dates3.length) - 1].end_time : '11:59:00';
      eventEndDate = new Date(eventContent.dates[(eventContent === null || eventContent === void 0 || (_eventContent$dates4 = eventContent.dates) === null || _eventContent$dates4 === void 0 ? void 0 : _eventContent$dates4.length) - 1].event_date + 'T' + _eventEndTime2);
    }
    if (eventContent.date && _typeof(eventContent.date) !== 'object') {
      var _eventStartTime3 = eventContent.start_time ? eventContent.start_time : '06:00:00';
      eventStartDate = _typeof(eventContent.date) === 'object' ? new Date(eventContent.date[0] + 'T' + _eventStartTime3) : new Date(eventContent.date + 'T' + _eventStartTime3);
      var _eventEndTime3 = eventContent.date.end_time ? eventContent.date.end_time : '11:59:00';
      eventEndDate = _typeof(eventContent.date) === 'object' ? new Date(eventContent.date[eventContent.date[0] - 1] + 'T' + _eventEndTime3) : new Date(eventContent.date + 'T' + _eventEndTime3);
    }
    if (eventContent.virtual_event === 'irl') {
      if (today >= eventStartDate) {
        rsvpLabel = eventContent.event_url ? 'View Now' : null;
        rsvpLink = eventContent.event_url ? eventContent.event_url : null;
      } else {
        rsvpLabel = eventContent.rsvp ? 'RSVP' : 'Get Notified';
        rsvpLink = eventContent.rsvp ? eventContent.rsvp : 'https://nycjewelryweek.com/join-us/';
        if (_typeof(rsvpLink) === 'object') {
          rsvpLink = rsvpLink.url;
        }
      }
    }
    if (eventContent.virtual_event !== 'irl') {
      if (today >= eventStartDate || Object.prototype.toString.call(eventStartDate) === '[object Date]') {
        rsvpLabel = null;
        rsvpLink = null;
        if (nycjwEventSettings.watch_live_link) {
          rsvpLabel = nycjwEventSettings.watch_live_link.title ? nycjwEventSettings.watch_live_link.title : 'Learn More';
          rsvpLink = nycjwEventSettings.watch_live_link.url;
        }
        if (eventContent.link) {
          rsvpLabel = eventContent.link.title ? eventContent.link.title : 'Learn More';
          rsvpLink = eventContent.link.url;
        }
        if (eventContent.instagram) {
          rsvpLabel = nycjwEventSettings.watch_live_link.title ? nycjwEventSettings.watch_live_link.title : 'Watch On Instagram';
          rsvpLink = 'https://instagram.com/nycjewelryweek';
        }
      } else {
        rsvpLabel = eventContent.rsvp && eventContent.rsvp.title ? eventContent.rsvp.title : 'Get Notified';
        rsvpLink = eventContent.rsvp ? eventContent.rsvp : 'https://nycjewelryweek.com/join-us/';
        if (_typeof(rsvpLink) === 'object') {
          rsvpLink = rsvpLink.url;
        }
      }
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "event-slideout",
    className: "".concat(loading ? 'loading' : '').concat(eventContent ? 'loaded' : '').concat(closing ? ' closing' : ''),
    onClick: closeSlideout
  }, /*#__PURE__*/React.createElement("div", {
    id: "event-slideout-wrapper",
    style: {
      borderColor: borderColor
    },
    ref: slideoutRef
  }, eventContent && /*#__PURE__*/React.createElement("div", {
    ref: slideoutClose,
    style: {
      borderColor: borderColor
    },
    onClick: closeSlideout,
    id: "close-slide"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Events"))), eventContent && /*#__PURE__*/React.createElement("div", {
    id: "event-slideout-content-wrapper",
    style: {
      paddingTop: 60
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "event-slideout-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-slideout-header"
  }, (eventContent.event_types || eventContent.event_themes) && /*#__PURE__*/React.createElement("div", {
    className: "top-wrapper"
  }, /*#__PURE__*/React.createElement("p", {
    className: "event-type"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      background: 'black',
      color: 'white'
    }
  }, eventContent.virtual_event === 'irl' ? 'In-person' : 'virtual'), eventContent.event_types && /*#__PURE__*/React.createElement("span", {
    style: {
      background: '#fef200',
      color: 'black'
    }
  }, eventContent.event_types && eventContent.event_types.length > 0 ? eventContent.event_types[0].name : '')), rsvpLink && /*#__PURE__*/React.createElement(React.Fragment, null, rsvpLink === 'mailinglist' ? /*#__PURE__*/React.createElement("a", {
    style: {
      cursor: 'pointer'
    },
    className: "btn rsvp-link mailinglist",
    onClick: function onClick(e) {
      e.preventDefault();
      document.body.classList.add('signup-active');
      document.body.classList.remove('modal-open');
      navigate('/virtual');
      setEventContent(null);
      window.scrollTo(0, scrollPos);
    }
  }, rsvpLabel) : /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    className: "btn rsvp-link",
    href: rsvpLink
  }, rsvpLabel))), /*#__PURE__*/React.createElement("h2", {
    dangerouslySetInnerHTML: {
      __html: eventContent.title ? eventContent.title : 'EVENT TITLE'
    }
  }), eventContent.images && /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement(Slider, _extends({
    className: "event-image-gallery"
  }, settings), eventContent.images.map(function (image) {
    return /*#__PURE__*/React.createElement("div", {
      key: image.id,
      className: "event-image-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "event-image",
      role: "img"
      // aria-label={ image.alt }
      ,
      style: {
        backgroundImage: "url(".concat(image.src, ")")
      }
    }));
  })))), (eventContent.dates && (eventContent === null || eventContent === void 0 || (_eventContent$dates5 = eventContent.dates) === null || _eventContent$dates5 === void 0 ? void 0 : _eventContent$dates5.length) > 0 || eventContent.start_date) && /*#__PURE__*/React.createElement("div", {
    className: "event-date",
    style: {
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: "underlined",
    style: {
      marginBottom: '1rem'
    }
  }, (eventContent === null || eventContent === void 0 || (_eventContent$dates6 = eventContent.dates) === null || _eventContent$dates6 === void 0 ? void 0 : _eventContent$dates6.length) == 1 ? 'Event Date' : 'Event Dates'), (eventContent === null || eventContent === void 0 || (_eventContent$dates7 = eventContent.dates) === null || _eventContent$dates7 === void 0 ? void 0 : _eventContent$dates7.length) > 0 && /*#__PURE__*/React.createElement("div", null, eventContent.dates.map(function (date, ind) {
    return /*#__PURE__*/React.createElement("span", {
      key: "date-".concat(ind)
    }, formatPrettyDate(date));
  }))), (eventContent.location_name || eventContent.location_address || eventContent.access_instructions) && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: "underlined",
    style: {
      marginBottom: '1rem'
    }
  }, "Location"), eventContent.location_name && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement("strong", null, eventContent.location_name)), eventContent.location_address && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 0,
      marginBottom: 0
    }
  }, eventContent.location_address.address), eventContent.access_instructions && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("div", {
    className: "special-instructions"
  }, /*#__PURE__*/React.createElement("sub", {
    style: {
      textTransform: 'uppercase',
      marginBottom: '1rem',
      marginTop: '1rem',
      fontWeight: '600',
      cursor: 'pointer'
    },
    className: "underlined"
  }, "Special Instructions:"), /*#__PURE__*/React.createElement("p", null, eventContent.access_instructions))), /*#__PURE__*/React.createElement("div", {
    id: "nycjw-event-map-wrapper",
    style: eventContent.location_address === "" ? {
      display: 'none'
    } : {}
  }, locationURL && /*#__PURE__*/React.createElement("button", {
    className: "btn small directions",
    onClick: function onClick() {
      return window.open(locationURL, '_blank');
    }
  }, "Get Directions"), /*#__PURE__*/React.createElement("div", {
    ref: mapContainer,
    id: "nycjw-event-map"
  })), eventContent.content && /*#__PURE__*/React.createElement("div", null, !eventContent.intro && /*#__PURE__*/React.createElement("h3", {
    className: "underlined",
    style: {
      marginBottom: '1rem'
    }
  }, "Description"), /*#__PURE__*/React.createElement("div", {
    className: "event-content",
    dangerouslySetInnerHTML: {
      __html: eventContent.content
    }
  }), params.type === 'virtual' && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", null, "Click ", /*#__PURE__*/React.createElement("b", null, "GET NOTIFIED"), " to be notified when this program is viewable.")), eventContent.social && eventContent.social.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "event-social"
  }, eventContent.project_url && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    title: "website",
    className: "project-url bold uppercase text-button social-link",
    href: eventContent.project_url
  }, /*#__PURE__*/React.createElement("img", {
    src: websiteIcon
  })), eventContent.social.map(function (social) {
    return /*#__PURE__*/React.createElement("a", {
      key: "social-".concat(social.type),
      title: social.type,
      className: "social-link social-".concat(social.type),
      target: "_blank",
      href: social.link
    }, /*#__PURE__*/React.createElement("img", {
      src: socialIcons[social.type]
    }));
  }))), eventContent.event_types && eventContent.event_types.length && (((_eventContent$event_t = eventContent.event_types[0]) === null || _eventContent$event_t === void 0 || (_eventContent$event_t = _eventContent$event_t.name) === null || _eventContent$event_t === void 0 ? void 0 : _eventContent$event_t.toLowerCase()) == 'talk' || ((_eventContent$event_t2 = eventContent.event_types[0]) === null || _eventContent$event_t2 === void 0 || (_eventContent$event_t2 = _eventContent$event_t2.name) === null || _eventContent$event_t2 === void 0 ? void 0 : _eventContent$event_t2.toLowerCase()) == 'performance' || ((_eventContent$event_t3 = eventContent.event_types[0]) === null || _eventContent$event_t3 === void 0 || (_eventContent$event_t3 = _eventContent$event_t3.name) === null || _eventContent$event_t3 === void 0 ? void 0 : _eventContent$event_t3.toLowerCase()) == 'panel') && eventContent.virtual_event == 'virtual' && !eventContent.hide_virtual && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '2rem',
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: '.25rem',
      marginTop: 0
    }
  }, /*#__PURE__*/React.createElement("strong", null, "NYCJW22 VIRTUAL PROGRAM")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: '.25rem',
      marginTop: 0
    }
  }, "Sections of this program will be released daily on YouTube and RSVP is required to access the stream. Remember to ", /*#__PURE__*/React.createElement("a", {
    style: {
      color: 'black',
      fontWeight: '600'
    },
    target: "_blank",
    href: "https://www.youtube.com/c/nycjewelryweek"
  }, "subscribe to NYC Jewelry Week\u2019s YouTube channel"), " for access to all of our content.")), eventContent.participants && eventContent.participants.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "event-participants"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "underlined"
  }, "Participants"), /*#__PURE__*/React.createElement("ul", null, eventContent.participants.map(function (participant, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "participant-".concat(index)
    }, /*#__PURE__*/React.createElement("h5", null, participant.name), participant.bio && /*#__PURE__*/React.createElement("div", {
      className: "participant-bio",
      dangerouslySetInnerHTML: {
        __html: participant.bio
      }
    }));
  }))) : '', eventContent.sponsor && eventContent.sponsor.name.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "event-participants sponsor_layout"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, "Sponsored By"), /*#__PURE__*/React.createElement("div", {
    className: "event-sponsors"
  }, /*#__PURE__*/React.createElement("a", {
    href: eventContent.sponsor.link,
    target: "_blank"
  }, eventContent.sponsor.image && eventContent.sponsor.image.length > 0 ? /*#__PURE__*/React.createElement("img", {
    src: eventContent.sponsor.image,
    className: "sponsor_logo"
  }) : '', /*#__PURE__*/React.createElement("span", null, eventContent.sponsor.name)), eventContent.sponsors && eventContent.sponsors.map(function (sponsor, sKey) {
    return /*#__PURE__*/React.createElement("a", {
      key: "sponsor-".concat(sKey),
      href: sponsor.link,
      target: "_blank"
    }, sponsor.image && sponsor.image.length > 0 ? /*#__PURE__*/React.createElement("img", {
      src: sponsor.image,
      className: "sponsor_logo"
    }) : '', /*#__PURE__*/React.createElement("span", null, sponsor.name));
  }))) : '', eventContent.is_discover && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, "DISCOVER"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Find Jewelry from this event at ", /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    style: {
      color: 'black'
    },
    href: "".concat(homeurl, "/discover")
  }, "DISCOVER")))), eventContent.virtual_event === 'In-person' && eventContent.covid_messaging && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '4rem'
    }
  }, eventContent.covid_messaging.heading && /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, eventContent.covid_messaging.heading), eventContent.covid_messaging.content && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: eventContent.covid_messaging.content
    }
  })), eventContent.supportEvents && eventContent.supportEvents.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "event-participants"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, "Supporting Events"), /*#__PURE__*/React.createElement("ul", null, eventContent.supportEvents.map(function (supportEvent, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "support-event-".concat(index)
    }, supportEvent.event_types && /*#__PURE__*/React.createElement("p", {
      className: "event-type"
    }, supportEvent.event_types.name && /*#__PURE__*/React.createElement("span", {
      style: {
        background: 'black',
        color: 'white'
      }
    }, supportEvent.event_types.name === 'irl' ? 'In-person' : supportEvent.event_types.name)), supportEvent.event && supportEvent.event.length > 0 ? /*#__PURE__*/React.createElement("h5", {
      dangerouslySetInnerHTML: {
        __html: supportEvent.event
      }
    }) : '', supportEvent.location && supportEvent.location.address && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, supportEvent.location.address)), supportEvent.date && /*#__PURE__*/React.createElement("div", {
      className: "event-date"
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: '1rem'
      }
    }, /*#__PURE__*/React.createElement("strong", null, _typeof(supportEvent.date) === 'object' ? formatPrettyDate(supportEvent.date) : formatPrettyDate(supportEvent)))), supportEvent.handle && /*#__PURE__*/React.createElement("div", {
      style: {
        cursor: 'pointer',
        textDecoration: 'underline',
        fontWeight: 600
      },
      onClick: function onClick() {
        return navigate("/".concat(params.event, "/").concat(supportEvent.handle));
      }
    }, "More Info"));
  }))) : '', /*#__PURE__*/React.createElement("div", {
    className: "text-centered follow-nycjw"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://instagram.com/nycjewelryweek",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    src: instagram
  }), /*#__PURE__*/React.createElement("span", null, "follow NYCJW on Instagram!"))))), loading && /*#__PURE__*/React.createElement("div", {
    className: "event-loading-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-loading"
  }, "Loading"))));
};
export default EventSlideout;